module.exports = __webpack_public_path__ + "components/intersport-discount-page/static/intersport-2560-529fa7fbb82c7cfb9b5366bee76791bb.jpg";